import { m } from '@pricedrop/i18n';
import { Link } from '@tanstack/react-router';
import { useId } from 'react';

function LogoIcon({ className }: { className?: string }) {
  const gradientId = useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      className={className}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#155dfc" />
          <stop offset="100%" stopColor="#9810fa" />
        </linearGradient>
      </defs>
      <rect width="512" height="512" rx="102" fill={`url(#${gradientId})`} />
      <path
        d="M97.42 350.58L136.14 350.58L136.14 288.75L170.29 288.75C213.84 288.75 238.85 262.73 238.85 225.28C238.85 188.08 214.22 161.42 171.18 161.42L97.42 161.42ZM136.14 257.52L136.14 193.41L163.94 193.41C187.68 193.41 198.86 206.23 198.86 225.28C198.86 244.32 187.68 257.52 164.07 257.52ZM322.41 350.58C379.92 350.58 414.58 315.03 414.58 255.87C414.58 196.97 379.92 161.42 323.05 161.42L255.89 161.42L255.89 350.58ZM294.61 317.19L294.61 194.81L320.76 194.81C356.94 194.81 375.99 213.60 375.99 255.87C375.99 298.40 356.94 317.19 320.51 317.19Z"
        fill="white"
      />
    </svg>
  );
}

export function Logo({ link = '/' }: { link?: string }) {
  return (
    <Link to={link} className="group flex items-center transition-transform hover:scale-105">
      <span className="hidden lg:flex items-center gap-3">
        <LogoIcon className="h-12 w-12 shrink-0 rounded-xl shadow-lg" />
        <div className="flex flex-col">
          <div className="text-2xl font-bold bg-gradient-to-r from-foreground to-foreground/70 bg-clip-text text-transparent">
            Pricedrop
          </div>
          <div className="text-xs font-medium text-muted-foreground whitespace-nowrap">
            {m.logo_subtitle()}
          </div>
        </div>
      </span>

      <span className="lg:hidden">
        <LogoIcon className="h-10 w-10 shrink-0 rounded-lg shadow-md" />
      </span>
    </Link>
  );
}
